module.exports = (url) => {
    // Need to check to handle different browsers
    const WindowURL = typeof(URL) === 'function' ? URL : window.webkitURL;

    try {
        return new WindowURL(url);
    } catch (err) {
        return false;
    }
};
